// /src/pages/InsightCenter.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./insight-center.css";
import wbLogo from "../../images/wealthbuilderslogo.png";
import VideoPlayer from "../../components/VideoPlayer";
import { fetchInsightCenterVideos } from "../../services/videoConfigService";

// Fallback URLs (in case Firestore fetch fails)
const FALLBACK_INTRO = "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/Insight%20center%2Finsight_center_intro_v2.mp4?alt=media&token=b6e04e29-69ca-4dc6-8754-75e5be9e1b5d";
const FALLBACK_EASTER_EGG = "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/Insight%20center%2FLeadership%20Bonus.mp4?alt=media&token=fe0c09c7-cf66-4d70-b93b-76b7c68d26df";

export default function InsightCenter() {
  const [showEasterEgg, setShowEasterEgg] = useState(false);
  const [videoData, setVideoData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadVideos = async () => {
      try {
        const data = await fetchInsightCenterVideos();
        setVideoData(data);
      } catch (error) {
        console.error("Failed to load insight center videos:", error);
      } finally {
        setLoading(false);
      }
    };
    loadVideos();
  }, []);

  const introVideoUrl = videoData?.mainIntro?.url || FALLBACK_INTRO;
  const easterEggVideoUrl = videoData?.easterEgg?.url || FALLBACK_EASTER_EGG;

  if (loading) {
    return (
      <div className="ic-wrap ic-centered">
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <p>Loading videos...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="ic-wrap ic-centered">
      {/* Intro Video - Centered */}
      <div className="ic-video-wrap ic-video-centered">
        <div className="ic-video">
          <div className="ic-video-inner">
            <VideoPlayer
              className="ic-video-player"
              src={introVideoUrl}
              title="Insight Center intro"
              controls
              muted
              playsInline
            />
          </div>
        </div>
      </div>

      <h3 className="ic-question">What would you like to learn more about?</h3>

      {/* Buttons as Links */}
      <div className="ic-btn-row">
        <Link
          className="ic-btn"
          to="/learn/business"
          role="button"
          aria-label="Learn about Business Education"
        >
          <span className="ic-btn-label">Business Education</span>
        </Link>
        <Link
          className="ic-btn"
          to="/learn/education"
          role="button"
          aria-label="Learn about Financial Education"
        >
          <span className="ic-btn-label">Financial Education</span>
        </Link>
      </div>

      {/* Easter Egg Logo */}
      <div className="ic-logo-container">
        <img 
          src={wbLogo} 
          alt="Wealth Builders" 
          className="ic-logo"
          onClick={() => setShowEasterEgg(true)}
          style={{ cursor: 'pointer' }}
        />
      </div>

      {/* Easter Egg Video Modal */}
      {showEasterEgg && (
        <div className="ic-modal-overlay" onClick={() => setShowEasterEgg(false)}>
          <div className="ic-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="ic-modal-close" onClick={() => setShowEasterEgg(false)}>
              ×
            </button>
            <div className="ic-modal-video">
              <VideoPlayer
                src={easterEggVideoUrl}
                title="Easter Egg Video"
                className="ic-modal-embed"
                controls
                autoPlay
                playsInline
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
